// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".eopoi-widget b>.v-icon{margin-left:-3px}", ""]);
// Exports
module.exports = exports;
